<template>
    <div class="form-group row mb-2">
        <label v-if="label && labelPosition !== 'above'" :for="theTarget" class="col col-form-label col-2 text-right">{{label}}: <alzata-required-indicator v-if="required" /></label>
        <div class="col input-container has-validation">
            <label v-if="label && labelPosition === 'above'" :for="theTarget">{{label}}: <alzata-required-indicator v-if="required" /></label>
            <slot v-bind="{required}" />
            <div class="invalid-feedback" v-if="validationMessage && typeof(validationMessage) === 'string'">{{validationMessage}}</div>
            <template v-if="validationMessage && typeof(validationMessage) === 'object'">
                <div class="invalid-feedback" v-for="(message, idx) in [...validationMessage]" :key="idx">{{message}}</div>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AlzataFormComponent',
    props: {
        label: String,
        labelPosition: String,
        required: Boolean,
        theTarget: String,
        validationMessage: {
        },
    },
    mounted() {
        console.log(this);
    },
};
</script>